/* template */
<template><div class="share-container"><Navbar isFixed :useDefaultBack="(false)" :navbarStyle="(navbarStyle)" @clickleft="gohome"/><mpx-image :class="(hideNavBar && 'lestop')" src="https://ut-static.udache.com/webx/sfc/q8zndB0RoZ8-Vf2sfE06i.png" mode="widthFix" class="main-bg"/><mpx-image :class="(hideNavBar && 'lestop')" src="https://ut-static.udache.com/webx/sfc/Ex-qwZBl0s7n2PlPnTagb.gif" mode="widthFix" class="main-gif"/><div :class="(hideNavBar && 'lestop')" class="main-content"><div class="help-coupon-list"><div class="help-coupon-list-title"><div class="normal-status" v-if="(status === 0)"><mpx-image src="https://ut-static.udache.com/webx/sfc/WTplWGsRIqvuRagGZtdYa.png" mode="heightFix" class="pic"/><div class="text">{{ totalAmount }}</div><mpx-image src="https://ut-static.udache.com/webx/sfc/T8MjIff8RzLkw-XBbpO_k.png" mode="heightFix" class="pic"/></div><mpx-image :src="(titlePic)" mode="heightFix" class="picb" v-else/></div><div class="reward-coupon-wrapper"><div :class="({'overdue': status === 2})" v-for="(item, index) in (rewardCouponList)" class="reward-coupon-item"><mpx-image :src="(cornermarkPic)" class="reward-coupon-item-cornermark"/><div :class="({'overdue': status === 2})" class="reward-coupon-item-left"><div :class="({'overdue': status === 2})" class="price"><div class="num">{{ getAmount(item) }}</div><div class="unit">元</div></div></div><div class="reward-coupon-item-right"><div :class="({'overdue': status === 2})" class="name" v-if="(item.name)">{{ item.name }}</div><div :class="({'overdue': status === 2})" class="remark" v-if="(item.remark)">{{ item.remark }}</div></div></div></div><mpx-image :src="(helpBtnPic)" mode="heightFix" @tap="assist" class="help-btn"/></div><mpx-image src="https://ut-static.udache.com/webx/sfc/wcTxsLUSvfHWtO5TMfZUf.png" mode="widthFix" class="share-guide"/><div class="dd-logo-wrapper"><mpx-image src="https://ut-static.udache.com/webx/sfc/Jpr5FbYElgbPq60oNurO6.png" class="dd-logo"/></div></div><success-popup :isPopupShow="(isPopupShow)" :totalAmount="(totalAmount)" :rewardCouponList="(rewardCouponList)" @close="requestFresh" @receive="receiveCoupon"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m6c471cca"}'>
  .share-container
    width 100%
    position relative
    overflow auto
    background #FF6F12
    .main-bg
      position absolute
      top 0
      left 0
      width 100%
      &.lestop
        top -44px
    .main-gif
      position absolute
      top 100px
      left 50%
      width 218px
      transform translateX(-50%)
      &.lestop
        top 56px
    .main-content
      width 100%
      padding 296px 16px 0 16px
      box-sizing border-box
      &.lestop
        padding-top 252px
      .help-coupon-list
        position relative
        width 100%
        background url('https://ut-static.udache.com/webx/sfc/siwAw7PrN3aNKa6kLCDHS.png')
        background-size cover
        background-repeat no-repeat
        height 403px
        display flex
        flex-direction column
        align-items center
        padding-top 4px
        box-sizing border-box
        border-radius 20px
        margin-bottom 7.5px
        padding 4px 12px
        .help-coupon-list-title
          display flex
          align-items center
          font-family Barlow Semi Condensed
          font-size 32px
          font-weight 400
          color #FF6427
          .normal-status
            display flex
            align-items center
          .pic
            height 22px
          .picb
            height 20px
            margin 15px 0
          .text
            line-height 45px
            margin 0 2px
        .reward-coupon-wrapper
          width 100%
          display flex
          flex-direction column
          align-items center
          margin-bottom 7.5px
          .reward-coupon-item
            width 100%
            position relative
            height 81px
            display flex
            align-items center
            background linear-gradient(264deg, #FFF5B5 -63%, #FFF9E7 67%, #FFFAEA 99%)
            box-sizing border-box
            border 1px solid #FFD69C
            border-radius 10px
            -webkit-mask radial-gradient(circle at 99px 4px, transparent 4px, #000 4px) 0 -3.8px
            mask radial-gradient(circle at 99px 4px, transparent 4px, #000 4px) 0 -3.8px
            &::before
              position absolute
              content ''
              width 6px
              height 6px
              top -3.9px
              left 94.2px
              border-radius 50%
              border 1px solid #FFD69C
            &::after
              position absolute
              content ''
              width 6px
              height 6px
              bottom -3.9px
              left 94.2px
              border-radius 50%
              border 1px solid #FFD69C
            &:not(:last-child)
              margin-bottom 10px
            &.overdue
              background #EBEBEB
              border-color #E2E2E2
            .reward-coupon-item-cornermark
              position absolute
              right 0
              top 0
              height 66px
              width 66px
              z-index 1
            .reward-coupon-item-left
              width 97.5px
              height 57.5px
              border-right 1px dotted #F7A774
              display flex
              justify-content center
              align-items center
              &.overdue
                border-color #B0B0B0
              .price
                display flex
                justify-content center
                align-items baseline
                color #FF6427
                &.overdue
                  color #999
                .num
                  font-family Barlow Semi Condensed
                  font-size 45px
                  font-weight 400
                  line-height 45px
                  letter-spacing 0px
                .unit
                  font-family PingFangSC-Regular
                  font-weight 400
                  font-size 16px
                  line-height 16px
                  text-align center
                  letter-spacing 0px
            .reward-coupon-item-right
              flex 1
              position relative
              z-index 2
              padding-left 20px
              display flex
              flex-direction column
              justify-content center
              .name
                font-family PingFangSC-Semibold
                font-size 16px
                font-weight 600
                line-height 16px
                letter-spacing 0px
                color #543018
                margin-bottom 5px
                &.overdue
                  color #999
              .remark
                font-family PingFangSC-Regular
                font-weight 400
                font-size 12px
                line-height 12px
                letter-spacing 0px
                color #B98664
                &.overdue
                  color #999
        .help-btn
          position absolute
          bottom 0
          left 50%
          transform translateX(-50%)
          height 80px
      .share-guide
        width 100%
      .dd-logo-wrapper
        width 100%
        display flex
        justify-content center
        margin 32px 0
        .dd-logo
          width 102px
          height 20px 
        
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6c471cca"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m6c471cca"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"component":true},
    // @ts-ignore
    {},
    // @ts-ignore
    {'success-popup':getComponent(require("./components/success-popup.mpx?isComponent&outputPath=components%2Fsuccess-popup89d103a4%2Findex")),'Navbar':getComponent(require("../../../node_modules/@didi/spring-ui/ts-navbar/index.mpx?isComponent&outputPath=components%2Findex268d26bb%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
